var _style, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJetAdventureLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 296 196.3",
    style: {
      enableBackground: "new 0 0 296 196.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#ffffff;}\n\t.st2{fill:url(#SVGID_2_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.6489,
    y1: 60.5336,
    x2: 169.3427,
    y2: 154.2352,
    gradientTransform: "matrix(1 0 0 -1 0 177.3333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004377176,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07578558,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1411,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1676,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2115,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2903,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3707,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3971,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5553,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6163,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7125,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8111,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8813,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9715,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9728,
    style: {
      stopColor: "#ffffff"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.5,90.1c0.9-2.2,1.7-4.5,2.3-6.8c-4.8,20.1-23.1,36.6-43.8,38.5c-20.7,2.6-41.3-9-50.9-26.2 c-1.3-2.1-3.5-6.5-4.4-8.9c-3.3-9.3-4.1-21-1.1-31.9c2.9-10.9,9.5-20.4,17-26.8c7.7-6.3,15.1-7.7,15-7.6c2.3-0.6,4.6-1,2.5,0 c-4.6,1.2-14.5,7.7-14,8.3c0.1,0.1,1.8-1.4,3.8-2.6c0.2,0.3,6.5-2.4,8.7-3c2-1.4,15.3-3,17.5-2.4c3.3,0.3-0.1,0.5-5.1,1.5 c-5,1-11.4,3.7-15,5.8c-3.6,2.1,0.3,0.5,0.4,0.8c-3.7,1.8-5.2,3.3-8.5,5.8c-0.1-0.1-8.8,8.8-11,14.8c0.1,0-1.3,1.7-3,7.7 c-0.5,2-0.6,2-0.7,2c0.1,0,0.1,0,0.2,0c-0.7,2-1,6.1-1.2,8.2c0.1,0,0.1,0,0.2,0c-0.4,4.2,0.3,8.3,1.1,12.4c0.1,0,0.1,0,0.2,0 c0.5,2,1.1,4,1.2,3.9c0.1,0,0.1,0,0.2-0.1c0.7,1.9,2.2,5.7,2.5,5.6c-0.1,0-0.1,0-0.2,0.1c3.6,7.4,8.2,11.8,13,15.4 c6.5,4.8,15.2,8.3,24.4,8.5c9.2,0.5,18.7-2.5,26.2-7.6c1.6-1.3,3.3-2.3,1.9-0.9c1.7-1.2,3.1-2.7,4.6-4.1c2.6-3.1,1.7-1.2,4.2-4.5 c10.2-13.1,11.9-32.5,4.2-47.4c-7.4-15.1-23.4-25.1-39.9-25c8.2,0.1,14.5,1.4,21.8,5.4c0-0.1,0.2-0.3,1.9,0.8 c11.3,6.3,18.5,20.2,20.1,26.3c0.6,2,1.8,4,2.2,10.5c0-2.2-0.4-4.3-0.7-6.4c0.1,0,0.3-0.1,0.3-0.1c1.9,8.5,0.9,19.8-2.6,27.9 c0,0,0.2,0.1,0.3,0.1c-0.6,1.3-1.2,2.7-1.9,4c-0.9,2.1,2.2-2,4.3-8.7c2.3-6.7,2.5-15.8,1.7-21.3c0.1,0,0.3,0,0.4-0.1 c0.3,1.5,0.3,3,0.4,4.5l0.2,0c-0.9-13.6-6.1-24.8-15.9-34c1.7,1.5,4.8,4.8,6,6.7c0.1-0.1,0.2-0.1,1.5,1.7 c-5-7.6-14.1-14.9-22.5-18.1c-2.1-0.8,0.3-0.7,6.4,2.4c5.9,3.5,9.5,6.5,13.9,11.7l0.2-0.1c-2.9-3.6-8.2-8.1-12.1-10.5 c-1.9-1.4,4,2.2,2.2,0.9c-2-1.2-3.9-2.6-5.9-3.6c6.3,2.9,13.5,9.1,17.6,14.8c1.5,1.8,2.8,3.7,3,3.6c6.1,10.1,7.8,19.8,8.5,27 C200.1,71.4,198.9,83.6,195.5,90.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.5,85.9c0,4.6,0,9,0,13.1c0,30.7-21,41-24.6,43.9c-0.9,0.7-1,1.2-1,2c0,0.7,0.7,1.4,1.5,1.4 c1,0,2.6-0.9,4.1-1.9c14.3-9.6,31.4-21.7,31.2-46.6l-0.1-16.7l-0.2-32L151.3,6l13.5-0.2l0-3.1h-39.1l0,3.1l13.3-0.1 c0.8,12.7,1.2,34.4,1.4,55.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.3458,
    y1: 121.2931,
    x2: 187.9878,
    y2: 121.2931,
    gradientTransform: "matrix(1 0 0 -1 0 177.3333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04398113,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05324907,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09774341,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1369,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1687,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1894,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2078,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2449,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2823,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4199,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5433,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6475,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6668,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7997,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8306,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    style: {
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9257,
    style: {
      stopColor: "#ffffff"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.7,81.2c13.8-5.5,29.5-11.9,31.9-29.4c-7.7,11.4-18.5,18.1-31.9,23.8l0-5.6c16.6-10.5,38.4-19.4,34-49.8 c-2.5,16.3-4.7,19.1-14.3,28.1c-2,1.9-12.5,9.6-19.7,14.5l0-3.2c13.9-13.7,34.4-28.8,28-55.7c-1.2,17.6-14.9,31.3-28,45.3 l-11.1,12.4c-10.8,13.3-18.1,27.7-11.5,46.5c0.2-3.6,0.1-6.8,0.6-10.4c0.7-5.3,5.1-8.8,11-11.8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.8,161.5c-0.5,0-1,0.1-1.3,0.3c-0.3,0.2-0.5,0.6-0.5,1v14.3c0,1.1-0.1,2-0.3,2.9c-0.2,0.8-0.5,1.6-1,2.3 c-0.4,0.7-1.1,1.5-2,2.2c-0.8,0.6-1.6,1.1-2.3,1.3c0.6-0.4,1.2-1,1.7-1.6c0.4-0.5,0.8-1,1-1.6c0.3-0.5,0.5-1.2,0.6-2.1 c0.1-0.9,0.2-1.6,0.2-2.3v-2.1v-1.8v-1.6v-1.3v-1.1v-1v-0.8v-0.7v-0.6v-0.5v-0.4c0-0.4,0-0.8,0-1.2c0-0.4,0-0.8,0-1.2 c0-0.8-0.1-1.4-0.4-1.8c-0.3-0.4-0.8-0.6-1.6-0.6l0.2-0.2H13L12.8,161.5L12.8,161.5z M24.7,178.1v-14.3c0-0.8-0.1-1.4-0.4-1.8 c-0.3-0.4-0.8-0.6-1.6-0.6l0.2-0.2H34l0.8,2.8l-0.2,0.1c-0.3-0.7-0.6-1.2-0.8-1.4c-0.5-0.5-1.2-0.8-2.1-0.8h-4.9v8l3.9-0.1 c0.8,0,1.3-0.1,1.7-0.4c0.4-0.3,0.6-0.8,0.6-1.6l0.3,0v4.5h-0.3c0-1.2-0.4-1.7-1.3-1.7c-0.9,0-1.7,0-2.5,0c-0.8,0-1.6,0-2.3,0 l0,6.9c0.1,0.5,0.3,0.8,0.6,1c0.3,0.2,0.8,0.3,1.4,0.3c0.6,0.1,1.3,0.1,2.2,0.1c0.4,0,0.7,0,1.1,0c0.3,0,0.7,0,1,0 c0.7,0,1.4-0.3,2-0.9c0.5-0.5,1-1.2,1.5-2.1l0.1,0.1l-1.3,3.6H22.8l0.2-0.3C24.2,179.4,24.7,179,24.7,178.1L24.7,178.1z  M59.9,164.1c-0.1-0.8-0.3-1.4-0.6-1.6c-0.4-0.3-1-0.5-1.7-0.5H53c0,1.8,0,4.3,0,7.6c0,3.3,0,5.8,0,7.5c0,0.8,0.1,1.4,0.4,1.8 c0.3,0.4,0.8,0.6,1.6,0.6l-0.2,0.3H49l0.2-0.3c1.2,0,1.7-0.4,1.7-1.3V162h-3.5c-1,0-1.8,0.2-2.6,0.7c-0.5,0.3-1,0.8-1.5,1.4 l-0.2-0.1l1.8-2.8h15.1l0,2.8L59.9,164.1L59.9,164.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.5,179.6v-0.5c0.4-0.1,0.8-0.2,1-0.3c0.3-0.1,0.4-0.3,0.4-0.6c0-0.3-0.1-0.7-0.3-1.2 c-0.2-0.5-0.3-0.9-0.4-1.1l-1-2.9c-0.6-0.1-1.4-0.1-2.7-0.1h-1.1c-1.1,0-2.1,0-3,0.2l-1,2.6c-0.5,1.1-0.7,1.8-0.7,2.1 c0,0.3,0.1,0.6,0.4,0.8c0.3,0.2,0.9,0.4,1.8,0.5v0.5c-1.1-0.1-2-0.2-2.8-0.2c-0.8,0-1.6,0-2.6,0.1v-0.4c0.6-0.1,1-0.4,1.3-0.7 c0.2-0.2,0.5-0.7,0.9-1.4c0.4-0.7,0.7-1.6,1.1-2.4c0.4-0.9,0.7-1.6,0.8-2l2.3-5.4c0.3-0.6,0.6-1.3,0.9-2c0.3-0.7,0.6-1.4,0.8-2.1 c0.3-0.7,0.5-1.3,0.6-1.7c0-0.1,0-0.2,0.1-0.3l0.5,0c0.3,1,0.6,2.1,1,3l3,8c0.8,2,1.3,3.5,1.7,4.4c0.4,1,0.7,1.6,1,2 c0.2,0.3,0.7,0.6,1.5,0.6v0.5c-0.8-0.1-1.5-0.1-2.2-0.1c-0.6,0-1.1,0-1.6,0c-0.5,0-0.9,0-1.2,0.1 C93.9,179.6,93.7,179.6,93.5,179.6z M89,166.9l-1.6,4.1c-0.2,0.6-0.4,1-0.4,1.1c0.7,0.1,1.5,0.2,2.5,0.2l1.3,0 c0.8,0,1.5,0,2.1-0.1c-0.3-1-0.5-1.5-0.6-1.7l-1-2.6c-0.1-0.3-0.3-0.8-0.6-1.5c-0.3-0.7-0.5-1.3-0.7-1.5 c-0.2,0.4-0.3,0.8-0.5,1.1C89.3,166.2,89.2,166.5,89,166.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.2,162l0-0.5c2.5,0,4.7-0.1,6.4-0.3c0.6-0.1,1.3-0.1,2-0.1c1.4,0,2.8,0.2,4,0.6c1.3,0.4,2.4,1,3.4,1.8 c1,0.8,1.8,1.8,2.4,2.9c0.6,1.1,0.9,2.4,0.9,3.8c0,1.7-0.4,3.3-1.3,4.7c-0.9,1.4-2.1,2.5-3.8,3.3c-1.6,0.8-3.5,1.2-5.6,1.2 c-0.1,0-0.5,0-1.1,0c-0.6,0-1,0-1.1,0c-0.4,0-0.7,0-1,0s-0.7,0-1.3,0c-0.6,0-1.1,0-1.6,0c-0.5,0-0.9,0-1,0l-1.4,0v-0.5 c1,0,1.6-0.2,1.8-0.7c0.2-0.5,0.3-2.9,0.3-7c0-2.8,0-4.8-0.1-6.2c-0.1-1.4-0.2-2.2-0.4-2.5C105.5,162.2,105,162,104.2,162z  M120.8,170.3c0-1.8-0.4-3.3-1.3-4.6s-1.9-2.3-3.3-2.9c-1.3-0.7-2.7-1-4.1-1c-1.4,0-2.6,0.3-3.7,0.7c-0.1,0.5-0.2,2.1-0.2,4.7 s-0.1,4.9-0.1,6.8c0,0.1,0,0.4,0,1.1c0,0.6,0,1.3,0,1.9c0,0.6,0,1,0,1.1c1,0.3,1.7,0.5,2.2,0.6c0.5,0.1,1.2,0.2,1.9,0.2 c1.9,0,3.6-0.4,4.8-1.3c1.3-0.8,2.2-1.9,2.7-3.2C120.5,173.1,120.8,171.7,120.8,170.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.6,161.7l0.1-0.5l1.1,0l2.3,0.1c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.8,0l1.4,0l0,0.5 c-0.8,0.1-1.3,0.1-1.5,0.2c-0.2,0.1-0.3,0.2-0.3,0.3c0,0.3,0.2,0.9,0.6,1.9c0.4,1,0.9,2.1,1.4,3.4c0.6,1.3,1,2.2,1.2,2.8l2,4.3 l0.4,0.8c0.3,0.6,0.5,1,0.6,1.2c0.3-0.6,0.7-1.3,1.1-2.2c0.4-0.9,0.9-1.8,1.3-2.6c0.4-0.8,0.6-1.3,0.6-1.4l1.9-4.1 c0.3-0.6,0.5-1.3,0.8-1.9c0.3-0.7,0.4-1.2,0.4-1.5c0-0.6-0.5-1-1.6-1.1l0.1-0.6c1.1,0.1,2.2,0.1,3.3,0.1c0.3,0,0.6,0,0.8,0 s0.5,0,0.9,0v0.4c-0.6,0.2-1.1,0.4-1.4,0.7s-0.6,0.6-0.9,1.2c-0.3,0.5-0.8,1.6-1.6,3.1l-3.2,6.3c-0.6,1.2-1.2,2.5-1.8,3.9 c-0.6,1.4-0.9,2.4-1,3.1l-0.4,0.1c-0.2-0.6-0.5-1.2-0.7-1.8l-1-2.1c-0.3-0.8-0.7-1.6-1.2-2.7l-2.4-5c-1.8-3.7-2.8-5.7-3.2-6.1 c-0.2-0.2-0.4-0.4-0.7-0.5C127.3,161.7,127,161.7,126.6,161.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.4,175.4h0.4c-0.2,1-0.3,1.8-0.5,2.4s-0.4,1.3-0.7,1.9c-0.3,0-0.7,0-1.3-0.1c-0.5,0-1.3,0-2.3,0 c-0.6,0-1.2,0-1.9,0c-0.7,0-1,0-0.9,0c-0.6,0-1.3,0-2.1,0c-0.8,0-1.8,0-2.9,0.1c-1.2,0-2,0.1-2.5,0.1l0-0.5 c0.3-0.1,0.6-0.1,0.9-0.2c0.3-0.1,0.5-0.2,0.6-0.3c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1,0.1-0.4,0.1-0.7c0.1-0.4,0.1-1,0.2-1.9 c0-0.9,0.1-2,0.1-3.2c0-1.2,0-1.9,0-2.2l-0.1-4.5c0-1.4-0.1-2.3-0.2-2.8c-0.1-0.5-0.2-0.8-0.5-1c-0.2-0.2-0.6-0.3-1.3-0.4 c0-0.2,0-0.3,0-0.4h9.1c1,0,2.6,0,4.6-0.1c0,0.8-0.1,1.6-0.3,2.4c-0.1,0.8-0.3,1.2-0.5,1.2c-0.2,0-0.3-0.1-0.3-0.2 c0-0.1,0-0.2,0.1-0.5c0-0.3,0.1-0.5,0.1-0.5c0-0.7-0.4-1.1-1.2-1.3c-0.8-0.2-1.8-0.3-3-0.3c-1.4,0-2.8,0.1-4.3,0.3 c-0.2,1.6-0.3,2.9-0.3,3.9c0,0.7,0,1.5,0,2.4c0,0.9,0,1.3,0,1.3c0.2,0,0.9,0,2.1,0c2,0,3.4,0,4.1-0.1c0.4,0,0.7-0.1,0.9-0.2 c0.1-0.1,0.3-0.2,0.4-0.5c0.1-0.3,0.3-0.7,0.4-1.2l0.4,0c0,1,0,1.9,0,2.6s0,1.7,0,2.7h-0.5c0-0.9-0.2-1.5-0.4-1.8 s-0.7-0.6-1.3-0.6c-0.7-0.1-1.8-0.1-3.5-0.1c-1.1,0-1.9,0-2.6,0.1l-0.1,2c-0.1,2.5,0,4.3,0.3,5.7c0.2,0,0.4,0.1,0.6,0.2 s0.5,0.1,0.7,0.1c0.2,0,0.5,0.1,0.9,0.1s0.9,0,1.5,0c1.5,0,2.6-0.1,3.5-0.3c0.8-0.2,1.5-0.6,1.9-1 C165.7,177,166.1,176.3,166.4,175.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.1,161.8v-0.6c0.9,0.1,1.4,0.1,1.6,0.1s0.5,0,0.8,0l1.2,0c0.6,0.7,1.2,1.5,2,2.3 c0.8,0.8,1.6,1.7,2.6,2.6c1,0.9,1.5,1.4,1.6,1.6l8.4,7.9c0.1-1.2,0.1-3,0.1-5.4v-2.7c0-1.5,0-2.6-0.1-3.3 c-0.1-0.7-0.2-1.3-0.4-1.6c-0.2-0.3-0.5-0.6-0.8-0.7c-0.3-0.1-0.9-0.2-1.6-0.4l0.2-0.4c0.1,0,0.4,0,0.7,0c0.3,0,0.6,0,0.9,0 c0.3,0,0.6,0,1,0.1c0.2,0,0.5,0,0.7,0s0.5,0,0.6,0l1.8,0l0,0.5c-0.6,0.1-1,0.2-1.2,0.4c-0.2,0.2-0.4,0.5-0.5,0.9 c-0.2,0.8-0.3,2.3-0.4,4.5c-0.1,2.3-0.1,4.4-0.1,6.5c0,0.8,0,1.6,0,2.3c0,0.7,0,1.4,0,2s0,1.1,0.1,1.6l-0.6,0 c-0.6-1.4-2.6-3.6-5.9-6.7l-5.3-5c-0.2-0.1-0.6-0.5-1.3-1.2c-0.7-0.6-1.6-1.5-2.6-2.5l-0.2,8.7c0,1.8,0,3,0.1,3.7 c0.1,0.7,0.4,1.2,0.8,1.4c0.4,0.2,1.2,0.5,2.4,0.7c0,0.2,0,0.4-0.1,0.5c-0.2,0-0.6,0-1.4-0.1c-0.8,0-1.2-0.1-1.4-0.1 s-0.7,0-1.6,0.1c-0.2,0-0.3,0-0.6,0c-0.3,0-0.6,0-1,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.3c0-0.1,0-0.2,0.1-0.3 c0,0,0.2,0,0.3-0.1c0.4,0,0.7-0.1,0.9-0.2c0.2-0.1,0.3-0.3,0.4-0.6c0.1-0.3,0.2-0.8,0.3-1.4c0-0.6,0.1-1.5,0.1-2.5l0.1-6.8 c0-1.5,0-2.6-0.1-3.3c-0.1-0.7-0.3-1.3-0.6-1.7C173.5,162.1,172.9,161.9,172.1,161.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.9,164.3l-0.5-0.1c0.4-1.2,0.8-2.3,1.2-3.4c0.2,0.2,0.4,0.3,0.5,0.4c0.1,0.1,0.3,0.1,0.6,0.1 c0.6,0.1,2,0.1,4.1,0.1h7.2c0.2,0,0.8,0,1.7,0c1,0,1.5,0,1.7,0c0.4,0,0.7,0,0.8-0.1c0.1,0,0.3-0.2,0.4-0.3 c0.1,0.1,0.2,0.3,0.4,0.3c-0.3,0.9-0.6,1.9-0.8,2.9l-0.6,0.1c0-0.3,0.1-0.7,0.1-1.3c-0.3-0.2-0.7-0.4-1.3-0.5 c-0.6-0.1-1.5-0.2-2.8-0.2c-1,0-1.6,0-1.9,0c-0.3,0-0.5,0-0.6,0.1c-0.1,0.1-0.1,0.2-0.1,0.4l-0.1,1.9c0,0.3,0,1.1-0.1,2.5 c0,0.3,0,1.3,0,2.8c0,1.5,0,2.8,0,3.9c0,1.4,0,2.4,0,3c0,0.6,0.1,1,0.2,1.3s0.3,0.5,0.6,0.6c0.3,0.1,0.7,0.2,1.4,0.3 c0.4,0,0.6,0.1,0.6,0.2c0,0.2,0,0.3,0,0.3c-0.1,0-0.3,0-0.6,0c-0.6,0-1.1-0.1-1.5-0.1c-0.6-0.1-1.1-0.1-1.5-0.1 c-0.9,0-1.9,0.1-3,0.3c-0.6,0.1-0.9,0.2-1,0.2c-0.1,0-0.2,0-0.3-0.1s-0.1-0.2-0.2-0.4c0.1,0,0.4-0.1,0.9-0.2 c0.7-0.2,1.1-0.3,1.4-0.4c0.3-0.1,0.5-0.3,0.5-0.5c0.1-0.2,0.1-0.5,0.1-0.9c0-0.5,0-1,0.1-1.6c0,0.1,0-0.5,0-1.7c0-1.2,0-2,0-2.5 c0-0.5,0-1.1,0-1.8c0-2,0-3.5,0-4.3c0-0.9,0-1.5-0.1-2c0-0.5-0.1-0.9-0.2-1.1c-0.8-0.1-1.7-0.1-2.7-0.1c-1,0-1.8,0-2.4,0.1 c-0.6,0.1-1,0.2-1.3,0.3c-0.3,0.2-0.5,0.3-0.6,0.5C199.3,163.5,199.1,163.9,198.9,164.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.1,161.9l0.1-0.5c0.4,0,1.1,0,2,0c1.6,0,3.2,0,4.7-0.1l0.2,0.5c-0.9,0.1-1.5,0.2-1.8,0.4 c-0.3,0.1-0.5,0.4-0.7,0.6c-0.3,0.5-0.4,2.7-0.4,6.6c0,1.3,0,2.5,0.1,3.5c0,1,0.1,1.8,0.2,2.4c0.3,1.4,1.1,2.4,2.3,2.8 c1.2,0.5,2.3,0.7,3.4,0.7c0.6,0,1.3-0.1,2.1-0.3s1.6-0.5,2.4-0.9c0.7-0.4,1.3-1,1.5-1.8c0.5-1.5,0.8-4.5,0.8-8.9 c0-1.3,0-2.3-0.1-3c-0.1-0.7-0.2-1.1-0.4-1.4c-0.2-0.3-0.4-0.5-0.7-0.5c-0.3-0.1-0.7-0.1-1.3-0.1l-0.1-0.5 c0.4-0.1,0.9-0.1,1.4-0.1c2,0,3.4,0,4.1,0v0.6c-0.6,0-1.1,0.1-1.3,0.2c-0.2,0.1-0.4,0.3-0.4,0.6c0,0.3-0.1,0.9-0.1,1.9 c0,1.8-0.1,3.4-0.1,4.8s-0.1,2.5-0.2,3.4c-0.1,0.9-0.2,1.7-0.4,2.4c-0.2,0.7-0.3,1.3-0.6,1.7c-0.4,0.8-1.1,1.4-2,1.9 c-0.9,0.4-1.8,0.7-2.8,0.9c-0.9,0.1-1.8,0.2-2.6,0.2c-1.3,0-2.5-0.2-3.5-0.6s-2-1-2.6-1.9c-0.7-0.9-1-2-1-3.4c0-0.3,0-1.3,0-2.8 c0-1.5,0-2.6,0-3.4c0-2.6-0.1-4.4-0.4-5.2c-0.1-0.2-0.2-0.3-0.3-0.4C223.4,162.1,222.9,162,222.1,161.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.6,173.2l-1.6-2.3c-1.3,0-2.3-0.1-3.1-0.2l0,3.4c0,0.7,0,1.5,0.1,2.4c0,0.9,0.1,1.5,0.3,1.9 c0.1,0.2,0.2,0.4,0.4,0.5c0.2,0.1,0.6,0.2,1.2,0.4c0.2,0,0.3,0.1,0.3,0.2c0,0.2-0.1,0.3-0.2,0.3c-0.2,0-0.6,0-1.2-0.1 c-0.8-0.1-1.3-0.1-1.5-0.1c-0.9,0-1.9,0.1-2.8,0.2c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3-0.1-0.3-0.3c0-0.1,0-0.2,0.1-0.2 c0.1,0,0.2-0.1,0.5-0.2c0.4-0.1,0.7-0.3,0.9-0.5c0.2-0.2,0.3-0.7,0.4-1.4c0.1-0.7,0.1-1.8,0.1-3.2v-6.3c0-1.5,0-2.6,0-3.4 c0-0.7-0.1-1.3-0.2-1.6s-0.3-0.6-0.6-0.7s-0.6-0.2-1.2-0.3l0.1-0.5c0.5,0,1.1,0,1.9,0c0.2,0,1-0.1,2.5-0.2 c1.4-0.1,2.3-0.2,2.7-0.2c1,0,1.9,0.1,2.7,0.4s1.5,0.6,2,1.1c0.5,0.5,0.9,1,1.2,1.6c0.3,0.6,0.4,1.2,0.4,1.8 c0,0.6-0.1,1.3-0.4,1.8c-0.3,0.6-0.7,1.1-1.3,1.6c-0.6,0.5-1.3,0.9-2.2,1.2l0.6,1c0.9,1.3,1.6,2.4,2.2,3.2 c0.6,0.8,1.2,1.6,1.9,2.4c0.7,0.8,1.4,1.4,2.1,1.9c0.7,0.5,1.4,0.7,2.1,0.8c0.2,0,0.3,0.1,0.3,0.3c0,0.1,0,0.1-0.1,0.2 c-0.1,0-0.3,0.1-0.6,0.1c-0.9,0-1.8-0.2-2.6-0.6c-0.9-0.4-1.7-0.9-2.4-1.6c-0.8-0.7-1.4-1.4-2-2.1 C257.1,175.4,256.4,174.4,255.6,173.2z M250.9,169.9c0.6,0.2,1.4,0.2,2.3,0.2c0.5,0,0.9,0,1.4-0.1s1-0.2,1.6-0.4 c0.5-0.2,1-0.6,1.4-1.1c0.4-0.5,0.6-1.3,0.6-2.2c0-0.6-0.2-1.3-0.5-2c-0.3-0.7-0.9-1.3-1.6-1.8c-0.7-0.5-1.6-0.8-2.6-0.8 c-0.4,0-0.9,0-1.4,0.2s-0.8,0.3-0.9,0.5C251,162.9,250.9,165.4,250.9,169.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285,175.4h0.4c-0.2,1-0.3,1.8-0.5,2.4c-0.2,0.6-0.4,1.3-0.7,1.9c-0.3,0-0.7,0-1.3-0.1c-0.5,0-1.3,0-2.3,0 c-0.6,0-1.2,0-1.9,0c-0.7,0-1,0-0.9,0c-0.6,0-1.3,0-2.1,0c-0.8,0-1.8,0-2.9,0.1c-1.2,0-2,0.1-2.5,0.1l0-0.5 c0.3-0.1,0.6-0.1,0.9-0.2c0.3-0.1,0.5-0.2,0.6-0.3c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1,0.1-0.4,0.1-0.7c0.1-0.4,0.1-1,0.2-1.9 c0-0.9,0.1-2,0.1-3.2c0-1.2,0-1.9,0-2.2l-0.1-4.5c0-1.4-0.1-2.3-0.2-2.8s-0.2-0.8-0.5-1s-0.6-0.3-1.3-0.4c0-0.2,0-0.3,0-0.4h9.1 c1,0,2.6,0,4.6-0.1c0,0.8-0.1,1.6-0.3,2.4c-0.1,0.8-0.3,1.2-0.5,1.2c-0.2,0-0.3-0.1-0.3-0.2c0-0.1,0-0.2,0.1-0.5 c0-0.3,0.1-0.5,0.1-0.5c0-0.7-0.4-1.1-1.2-1.3c-0.8-0.2-1.8-0.3-3-0.3c-1.4,0-2.8,0.1-4.3,0.3c-0.2,1.6-0.3,2.9-0.3,3.9 c0,0.7,0,1.5,0,2.4c0,0.9,0,1.3,0,1.3c0.2,0,0.9,0,2.1,0c2,0,3.4,0,4.1-0.1c0.4,0,0.7-0.1,0.9-0.2s0.3-0.2,0.4-0.5 s0.3-0.7,0.4-1.2l0.4,0c0,1,0,1.9,0,2.6s0,1.7,0,2.7h-0.5c0-0.9-0.2-1.5-0.4-1.8s-0.7-0.6-1.3-0.6c-0.7-0.1-1.8-0.1-3.5-0.1 c-1.1,0-1.9,0-2.6,0.1l-0.1,2c-0.1,2.5,0,4.3,0.3,5.7c0.2,0,0.4,0.1,0.6,0.2s0.5,0.1,0.7,0.1c0.2,0,0.5,0.1,0.9,0.1 c0.4,0,0.9,0,1.5,0c1.5,0,2.6-0.1,3.5-0.3c0.8-0.2,1.5-0.6,1.9-1C284.3,177,284.7,176.3,285,175.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJetAdventureLogoColor);
export default __webpack_public_path__ + "static/media/jet-adventure-logo-color.061b78a73849f7bbb9aaeee8d0170932.svg";
export { ForwardRef as ReactComponent };